import { makeStyles } from "@mui/styles";
import background from "../../assets/images/bg-inside.jpg";

const useAuthorizationStyles = makeStyles(() => ({
    main: {
        width: "100%",
        height: "calc(100% - 130px)",
        backgroundImage: `url(${background})`,
        position: "fixed",
    },
    mainBox: {
        padding: "10px 20px",
        overflow: "auto",
        position: "absolute",
        display: "flex",
        height: "100%",
    },
}));

export default useAuthorizationStyles;
